import { render, staticRenderFns } from "./UserFilter.vue?vue&type=template&id=72b1d703&scoped=true&"
import script from "./UserFilter.vue?vue&type=script&lang=ts&"
export * from "./UserFilter.vue?vue&type=script&lang=ts&"
import style0 from "./UserFilter.vue?vue&type=style&index=0&id=72b1d703&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b1d703",
  null
  
)

export default component.exports